import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import LogoImage from '../assets/logo-navbar-hk.svg';
import ContactForm from './ContactForm';
import Quiz from './Quiz';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenQuiz, setIsModalOpenQuiz] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  const closeNav = () => {
    setNav(false);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setNav(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenModalQuiz = () => {
    setIsModalOpenQuiz(true);
    setNav(false);
  };

  const handleCloseModalQuiz = () => {
    setIsModalOpenQuiz(false);
  };

  return (
    <>
      <nav
        className="fixed top-0 left-0 w-full bg-white shadow-lg z-40 flex justify-between items-center mx-auto px-4"
        style={{
          height: window.innerWidth < 750 ? '68px' : '88px',
        }}
        role="navigation"
        aria-label="Navegación principal"
      >
        <Link to="/" className="flex items-center" aria-label="Ir al inicio">
          <img
            src={LogoImage}
            alt="Logo de Fundación HK"
            className="transition-transform duration-300 hover:scale-105"
            style={{
              width: window.innerWidth < 750 ? '156px' : '364px',
              height: window.innerWidth < 750 ? '39px' : '91px',
              backgroundColor: 'transparent'
            }}
          />
        </Link>

        <ul className="hidden md:flex items-center space-x-4" role="menubar">
          <li role="none">
            <Link 
              to="/home" 
              className="p-4 text-fhk-orange-500 hover:text-fhk-orange-600 transition-colors duration-200 font-bold"
              role="menuitem"
              aria-label="Ir a la página de inicio"
            >
              Inicio
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/quienes-somos" 
              className="p-4 text-fhk-orange-500 hover:text-fhk-orange-600 transition-colors duration-200 font-bold whitespace-nowrap"
              role="menuitem"
              aria-label="Ir a la página quienes somos"
            >
              Quiénes Somos
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/nuestros-programas" 
              className="p-4 text-fhk-orange-500 hover:text-fhk-orange-600 transition-colors duration-200 font-bold"
              role="menuitem"
              aria-label="Ir a la página de programas"
            >
              Programas
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/colegios" 
              className="p-4 text-fhk-orange-500 hover:text-fhk-orange-600 transition-colors duration-200 font-bold"
              role="menuitem"
              aria-label="Ir a la página de colegios"
            >
              Colegios
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/alianzas" 
              className="p-4 text-fhk-orange-500 hover:text-fhk-orange-600 transition-colors duration-200 font-bold"
              role="menuitem"
              aria-label="Ir a la página de alianzas"
            >
              Alianzas
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/noticias" 
              className="p-4 text-fhk-orange-500 hover:text-fhk-orange-600 transition-colors duration-200 font-bold"
              role="menuitem"
              aria-label="Ir a la página de noticias"
            >
              Noticias
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/contacto" 
              className="p-4 text-fhk-orange-500 hover:text-fhk-orange-600 transition-colors duration-200 font-bold"
              role="menuitem"
              aria-label="Ir a la página de contacto"
            >
              Contacto
            </Link>
          </li>
          <li role="none">
            <button 
              className="bg-fhk-orange-500 text-white px-6 py-3 md:px-8 md:py-4 rounded-full font-semibold text-base md:text-lg hover:bg-fhk-orange-600 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap" 
              onClick={handleOpenModal}
              aria-label="Contactar con Fundación HK"
            >
              Únete a Fundación HK
            </button>
          </li>
        </ul>

        <button 
          onClick={handleNav} 
          className="block md:hidden p-2 text-fhk-orange-500 hover:text-fhk-orange-600 hover:bg-orange-50 rounded transition-colors duration-200"
          aria-label={nav ? "Cerrar menú de navegación" : "Abrir menú de navegación"}
          aria-expanded={nav}
          aria-controls="mobile-menu"
        >
          {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
        </button>

        {/* Mobile Menu */}
        <ul
          id="mobile-menu"
          style={{
            backgroundColor: '#1d979d',
            left: nav ? '0' : '-100%',
            width: '60%',
            textAlign: 'center',
            position: 'fixed',
            top: '0',
            height: '100%',
            transition: 'left 0.5s ease-in-out',
            zIndex: 50,
            paddingTop: '2rem',
            color: 'white',
            fontSize: '1.1rem',
            fontWeight: '500'
          }}
          className="md:hidden"
          role="menu"
          aria-label="Menú de navegación móvil"
        >
          <li role="none">
            <Link 
              to="/home" 
              onClick={closeNav}
              className="block p-4 hover:bg-white hover:bg-opacity-20 transition-colors duration-200"
              role="menuitem"
            >
              Inicio
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/quienes-somos" 
              onClick={closeNav}
              className="block p-4 hover:bg-white hover:bg-opacity-20 transition-colors duration-200 whitespace-nowrap"
              role="menuitem"
            >
              Quiénes Somos
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/nuestros-programas" 
              onClick={closeNav}
              className="block p-4 hover:bg-white hover:bg-opacity-20 transition-colors duration-200"
              role="menuitem"
            >
              Programas
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/colegios" 
              onClick={closeNav}
              className="block p-4 hover:bg-white hover:bg-opacity-20 transition-colors duration-200"
              role="menuitem"
            >
              Colegios
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/alianzas" 
              onClick={closeNav}
              className="block p-4 hover:bg-white hover:bg-opacity-20 transition-colors duration-200"
              role="menuitem"
            >
              Alianzas
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/noticias" 
              onClick={closeNav}
              className="block p-4 hover:bg-white hover:bg-opacity-20 transition-colors duration-200"
              role="menuitem"
            >
              Noticias
            </Link>
          </li>
          <li role="none">
            <Link 
              to="/contacto" 
              onClick={closeNav}
              className="block p-4 hover:bg-white hover:bg-opacity-20 transition-colors duration-200"
              role="menuitem"
            >
              Contacto
            </Link>
          </li>
          <li role="none">
            <button 
              className="block w-full p-4 text-left hover:bg-white hover:bg-opacity-20 transition-colors duration-200"
              onClick={handleOpenModal}
              aria-label="Contactar con Fundación HK"
            >
              Únete a Fundación HK
            </button>
          </li>
        </ul>
      </nav>

      {/* Contact Form Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-2 sm:px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" onClick={handleCloseModal}></div>
            <div className="inline-block w-full max-w-6xl p-2 sm:p-4 my-4 sm:my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <div className="flex justify-end">
                <button
                  onClick={handleCloseModal}
                  className="text-gray-400 hover:text-gray-600 transition-colors duration-200 p-2"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      )}

      {/* Quiz Modal */}
      {isModalOpenQuiz && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" onClick={handleCloseModalQuiz}></div>
            <div className="inline-block w-full max-w-4xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <div className="flex justify-end">
                <button
                  onClick={handleCloseModalQuiz}
                  className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <Quiz onClose={handleCloseModalQuiz} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
